import { FormControl, Input, InputLabel, TextField, Typography } from '@mui/material'
import React from 'react'

export const InputText = ({ label, readOnly, value, validation, onChange, name, type = 'text', className = '', localValidation = [], serverErrors = {}, disabled=false  }: any) => {

     const validations = validated(localValidation, serverErrors, name)


    return (
        <FormControl fullWidth variant="standard">
            {
                readOnly ?
                    <>
                        <Typography variant='body2' className='mb-1' component="span">
                            {label}
                        </Typography>
                        <Typography variant='body1' className="my-0 pb-1" component="span">
                            {value || '-'}
                        </Typography>
                    </> :
                    <>
                        {/* <InputLabel htmlFor="standard-adornment-amount">
                            {label}
                        </InputLabel> */}
                        <TextField
                            variant="standard"
                            value={value}
                            label={label}
                            onChange={onChange}
                            name={name}
                            type={type}
                            {...validations}
                            className={className}
                            disabled={disabled}
                        />
                    </>
            }
        </FormControl>
    )
}

const validated = (localValidation: any, serverErrors: any, fieldName: string) => {

    //console.log(serverErrors);

    const serverMessages = serverErrors?.[fieldName] || []  // aquí busca el nombre exacto
    const localMessages = localValidation.filter((v: any) => !v.isOk).map((v: any) => v.msgError)
    const allMessages = [...localMessages, ...serverMessages]

    return allMessages.length > 0
        ? {
            error: true,
            helperText: allMessages.map((msg: string, i: number) => <span key={i}>{msg}</span>)
        }
        : {}
}

